var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "finance" },
    [
      _c("new-transaction-modal", {
        ref: "typeModal",
        on: { submitted: _vm.modalIsSubmitted },
      }),
      _c("edit-transaction-modal", {
        ref: "editTransactionModal",
        on: { submitted: _vm.modalIsSubmitted },
      }),
      _c("m-finance-transaction", {
        ref: "depositModal",
        attrs: {
          active: _vm.isShowFinanceTransactionModal,
          type: _vm.switcherLocal,
          "current-user-personal-amount": _vm.personalAccountAmountLocal,
        },
        on: {
          close: function ($event) {
            _vm.isShowFinanceTransactionModal = false
          },
          submitPersonalAccount: _vm.addDataToPersonalAccount,
          submitDeposit: _vm.addDataToDeposit,
          submitAccountableTransaction: _vm.addDataToAccountableTransaction,
        },
      }),
      _c("m-remove-transaction", {
        ref: "removeTransaction",
        on: { remove: _vm.removeTransactionSubmit },
      }),
      _c(
        "div",
        { staticClass: "finance__header" },
        [
          _vm.userHavePermissionDeposit() ||
          _vm.userHavePermissionPersonalAccount() ||
          _vm.userHavePermissionAccountable()
            ? _c("c-switcher", {
                staticClass: "finance__switcher h-switcher",
                attrs: { type: "group", items: _vm.switcherLocalItems },
                model: {
                  value: _vm.switcherLocal,
                  callback: function ($$v) {
                    _vm.switcherLocal = $$v
                  },
                  expression: "switcherLocal",
                },
              })
            : _vm._e(),
          _c(
            "div",
            { staticClass: "finance-change" },
            [
              _vm.switcherLocal === "personal_account"
                ? _c(
                    "div",
                    {
                      staticClass: "finance-change-personal-account-amount",
                      class: {
                        "finance-change-personal-account-amount-red":
                          _vm.personalAccountAmountLocal < 0,
                        "finance-change-personal-account-amount-black":
                          _vm.personalAccountAmountLocal === 0,
                        "finance-change-personal-account-amount-green":
                          _vm.personalAccountAmountLocal > 0,
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.formatAmount(_vm.personalAccountAmountLocal)
                          ) +
                          " " +
                          _vm._s(_vm.currencyLabel) +
                          " "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.switcherLocal === "deposit"
                ? _c("div", { staticClass: "finance-change-deposit" }, [
                    _c(
                      "div",
                      {
                        staticClass: "finance-change-deposit-amount",
                        class: {
                          "finance-change-deposit-amount-yellow":
                            _vm.depositAmountLocal > 0 &&
                            _vm.depositAmountLocal < _vm.depositAmountMaxLocal,
                          "finance-change-deposit-amount-red":
                            _vm.depositAmountLocal >
                              _vm.depositAmountMaxLocal ||
                            _vm.depositAmountLocal <= 0,
                          "finance-change-deposit-amount-green":
                            _vm.depositAmountLocal ===
                            _vm.depositAmountMaxLocal,
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.formatAmount(_vm.depositAmountLocal)) +
                            " " +
                            _vm._s(_vm.currencyLabel) +
                            " "
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "finance-change-deposit-description" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "finance-change-deposit-description-count",
                          },
                          [
                            _vm._v(" из "),
                            _c("b", [
                              _vm._v(_vm._s(_vm.depositAmountMaxLocal)),
                            ]),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(_vm.currencyLabel))]),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "finance-change-deposit-description-desc",
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.getDepositAmountStatus()) + " "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm.switcherLocal === "accountable-transaction"
                ? _c(
                    "div",
                    {
                      staticClass: "finance-change-personal-account-amount",
                      class: {
                        "finance-change-personal-account-amount-red":
                          _vm.accountableTransactionAmountLocal < 0,
                        "finance-change-personal-account-amount-gray":
                          _vm.accountableTransactionAmountLocal === 0,
                        "finance-change-personal-account-amount-green":
                          _vm.accountableTransactionAmountLocal > 0,
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.formatAmount(
                              _vm.accountableTransactionAmountLocal
                            )
                          ) +
                          " " +
                          _vm._s(_vm.currencyLabel) +
                          " "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.displayFinanceChangeButton
                ? _c("c-button", {
                    staticClass: "finance-change-button",
                    attrs: { label: "Внести/снять средства" },
                    on: {
                      click: function ($event) {
                        return _vm.showTransactionModal()
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "finance-change-history" },
        [
          _c("div", { staticClass: "finance-change-history-title" }, [
            _vm._v("История изменений"),
          ]),
          _c(
            "div",
            {
              staticClass: "finance-change-filters",
              class: {
                "finance-change-filters--hide":
                  !_vm.areFiltersExpanded || !_vm.areFiltersExpandedMobile,
                "finance-change-filters--deposit":
                  _vm.switcherLocal === "deposit",
              },
            },
            [
              _c(
                "div",
                { staticClass: "finance-change-filters-row row" },
                [
                  _vm.switcherLocal === "personal_account"
                    ? _c("c-button", {
                        staticClass:
                          "finance-change-filters__switcher finance-change-filters__switcher--mobile",
                        attrs: {
                          label: _vm.areFiltersExpandedMobile
                            ? "Свернуть фильтры"
                            : "Показать фильтры",
                          size: "small",
                        },
                        on: { click: _vm.expandHideFiltersMobile },
                      })
                    : _vm._e(),
                  _vm.areFiltersExpandedMobile
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "col col-12 col-md-4 col-xl-3 col--transaction-date-period",
                        },
                        [
                          _c("c-input", {
                            ref: "financePeriod",
                            staticClass:
                              "finance-change-history-filters-period",
                            attrs: {
                              label: "Период учётной даты",
                              placeholder: "00.00.0000 - 00.00.0000",
                              type: "period",
                              icon: "calendar",
                              clearable: _vm.periodLocal,
                              "icon-right": true,
                            },
                            model: {
                              value: _vm.periodLocal,
                              callback: function ($$v) {
                                _vm.periodLocal = $$v
                              },
                              expression: "periodLocal",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.switcherLocal === "personal_account" &&
                  _vm.areFiltersExpandedMobile
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "col col-12 col-md-8 col-xl-5 col--transaction-type",
                        },
                        [
                          _c("c-select-2", {
                            attrs: {
                              type: "select",
                              label: "Тип проводки",
                              multiple: true,
                              searchable: true,
                              placeholder: "Любой",
                              items: _vm.transactionTypes.items,
                              groups: _vm.transactionTypes.groups,
                              checkbox: true,
                              "checkbox-value": _vm.transactionTypes.reverse,
                              "checkbox-type": "icon",
                              "checkbox-tooltip": {
                                disabledText:
                                  "Фильтр по всем значениям в справочнике, кроме выбранных",
                                activeText:
                                  "Выключить фильтр по всем значениям в справочнике, кроме выбранных",
                                notActiveText:
                                  "Включить фильтр по всем значениям в справочнике, кроме выбранных",
                              },
                              useCustomColors: true,
                            },
                            on: {
                              checkboxChange: function ($event) {
                                _vm.transactionTypes.reverse = $event
                              },
                            },
                            model: {
                              value: _vm.filtersForm.selectedTransactionTypes,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.filtersForm,
                                  "selectedTransactionTypes",
                                  $$v
                                )
                              },
                              expression:
                                "filtersForm.selectedTransactionTypes",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.switcherLocal === "personal_account" &&
                  _vm.areFiltersExpanded &&
                  _vm.areFiltersExpandedMobile
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "col col-12 col-md-4 col-xl-2 col--transaction-id",
                        },
                        [
                          _c("c-input", {
                            attrs: {
                              type: "text",
                              label: "№ ведомости/проводки",
                              placeholder: "Любой",
                              clearable: true,
                            },
                            model: {
                              value: _vm.filtersForm.selectedTransactionId,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.filtersForm,
                                  "selectedTransactionId",
                                  $$v
                                )
                              },
                              expression: "filtersForm.selectedTransactionId",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.switcherLocal === "personal_account" &&
                  _vm.areFiltersExpanded &&
                  _vm.areFiltersExpandedMobile
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "col col-12 col-md-4 col-xl-3 col--transaction-filial",
                        },
                        [
                          _c("c-select-2", {
                            attrs: {
                              type: "select",
                              label: "Филиал",
                              multiple: true,
                              searchable: true,
                              placeholder: "Все",
                              items: _vm.referencesByColumns.filial,
                              "checkbox-value": _vm.filials.reverse,
                              checkbox: true,
                              "checkbox-type": "icon",
                              "checkbox-tooltip": {
                                disabledText:
                                  "Фильтр по всем значениям в справочнике, кроме выбранных",
                                activeText:
                                  "Выключить фильтр по всем значениям в справочнике, кроме выбранных",
                                notActiveText:
                                  "Включить фильтр по всем значениям в справочнике, кроме выбранных",
                              },
                              useCustomColors: true,
                            },
                            on: {
                              checkboxChange: function ($event) {
                                _vm.filials.reverse = $event
                              },
                            },
                            model: {
                              value: _vm.filtersForm.selectedFilials,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.filtersForm,
                                  "selectedFilials",
                                  $$v
                                )
                              },
                              expression: "filtersForm.selectedFilials",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.switcherLocal === "personal_account" &&
                  _vm.areFiltersExpanded &&
                  _vm.areFiltersExpandedMobile
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "col col-12 col-md-4 col-xl-3 col--transaction-post",
                        },
                        [
                          _c("c-select-2", {
                            attrs: {
                              type: "select",
                              label: "Должность",
                              placeholder: "Все",
                              items: _vm.posts.items,
                              clearable: true,
                            },
                            model: {
                              value: _vm.filtersForm.selectedPost,
                              callback: function ($$v) {
                                _vm.$set(_vm.filtersForm, "selectedPost", $$v)
                              },
                              expression: "filtersForm.selectedPost",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col col-12 col-md-12 col-xl-4 offset-xl-2 col--actions",
                    },
                    [
                      _vm.switcherLocal === "personal_account"
                        ? _c("c-button", {
                            staticClass:
                              "arrow-button finance-change-filters__switcher finance-change-filters__switcher--desktop",
                            class: {
                              "expanded-filters": !_vm.areFiltersExpanded,
                            },
                            attrs: { icon: "chevron" },
                            on: { click: _vm.expandHideFilters },
                          })
                        : _vm._e(),
                      _vm.switcherLocal === "personal_account" &&
                      _vm.areFiltersExpandedMobile
                        ? _c("c-button", {
                            staticClass:
                              "finance-change-filters__switcher finance-change-filters__switcher--mobile",
                            attrs: {
                              label: _vm.areFiltersExpanded
                                ? "Свернуть фильтры"
                                : "Показать фильтры",
                              size: "small",
                            },
                            on: { click: _vm.expandHideFiltersMobile },
                          })
                        : _vm._e(),
                      _vm.switcherLocal === "personal_account" &&
                      _vm.areFiltersExpandedMobile
                        ? _c("c-button", {
                            staticClass: "action-button",
                            attrs: { label: "Сбросить", size: "large" },
                            on: { click: _vm.resetFilters },
                          })
                        : _vm._e(),
                      _vm.switcherLocal === "personal_account" &&
                      _vm.areFiltersExpandedMobile
                        ? _c("c-button", {
                            staticClass: "action-button",
                            attrs: { label: "Применить", color: "primary" },
                            on: { click: _vm.applyFilters },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm.switcherLocal === "personal_account"
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "col col-12 col-md-12 col-xl-12 col--table-actions",
                        },
                        [
                          _vm.canRestoreTransactions
                            ? _c("c-switcher", {
                                staticClass:
                                  "finance__switcher h-switcher finance-account-status",
                                attrs: {
                                  type: "group",
                                  items: [
                                    { label: "Активные", value: "active" },
                                    { label: "Удаленные", value: "removed" },
                                  ],
                                },
                                model: {
                                  value: _vm.operationsStatus,
                                  callback: function ($$v) {
                                    _vm.operationsStatus = $$v
                                  },
                                  expression: "operationsStatus",
                                },
                              })
                            : _vm._e(),
                          _c("c-button-dropdown", {
                            staticClass: "olap-actions",
                            attrs: {
                              icon: "arrow",
                              type: "dropdown",
                              label: "Действия",
                              dropdown: {
                                position: "left",
                                items: [
                                  {
                                    icon: "filter-drop",
                                    iconColor: "secondary",
                                    label: "Сбросить фильтры столбцов",
                                    emit: "resetColumnFilters",
                                    class: `${
                                      this.tableDataPersonal
                                        .activeFilteredColumns.length
                                        ? ""
                                        : "disabled"
                                    }`,
                                  },
                                  {
                                    icon: "cog",
                                    label: "Настроить столбцы",
                                    emit: "openColumnSettingsModal",
                                  },
                                  {
                                    icon: "google",
                                    iconColor: "success",
                                    label: "Выгрузить в Google Таблицы",
                                    emit: "changeGoogleFormSubmit",
                                  },
                                  {
                                    icon: "print",
                                    label: "Распечатать расчетный лист",
                                    emit: "print",
                                  },
                                ],
                              },
                            },
                            on: {
                              resetColumnFilters: _vm.resetColumnFilters,
                              openColumnSettingsModal:
                                _vm.openColumnSettingsModal,
                              changeGoogleFormSubmit:
                                _vm.changeGoogleFormSubmit,
                              print: _vm.print,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]
          ),
          _c("google-form", {
            staticClass: "google-form",
            staticStyle: { display: "none" },
            attrs: {
              sp: _vm.sp,
              googleFormIsSubmitted: _vm.googleFormIsSubmitted,
            },
          }),
          _c("m-table-settings", {
            ref: "columnSettings",
            attrs: {
              columns: _vm.defaultColumns,
              "disabled-columns": _vm.tableDataPersonal.disabledColumns,
              "default-disabled-columns":
                _vm.tableDataPersonal.defaultDisabledColumns,
            },
            on: { apply: _vm.submitTableSettings },
          }),
          _c(
            "div",
            { staticClass: "finance-change-history-table" },
            [
              !_vm.isLoadingData && _vm.switcherLocal === "personal_account"
                ? _c("c-data-table", {
                    ref: "accountHistory",
                    staticClass:
                      "finance-change-history-table-personal-account'",
                    attrs: {
                      levels: 1,
                      "sorted-column": _vm.tableDataPersonal.sortedColumn,
                      "disabled-columns": _vm.tableDataPersonal.disabledColumns,
                      "filtered-columns": _vm.tableDataPersonal.filteredColumns,
                      "active-filtered-columns":
                        _vm.tableDataPersonal.activeFilteredColumns,
                      data: _vm.tableDataPersonal,
                      "reference-list": _vm.referenceFilterList,
                      "empty-records-label": "Записи не найдены",
                      "operations-status": _vm.operationsStatus,
                    },
                    on: {
                      sortedEvent: _vm.onTableSort,
                      getReferenceValues: _vm.setColumnReferenceFilterList,
                      "reset-column-filters": function ($event) {
                        _vm.tableDataPersonal.activeFilteredColumns = []
                      },
                      "remove-column-filter": _vm.onColumnFilterRemove,
                      "set-column-filter": _vm.onSetColumnFilter,
                      "set-column-filter-by-index":
                        _vm.onSetColumnFilterByIndex,
                      "disable-column-sorted-flag":
                        _vm.onDisableColumnSortedFlag,
                      "change-sorting-column": _vm.onSortingColumnChange,
                      remove: _vm.removeTransaction,
                      restore: _vm.restoreTransaction,
                      editRecord: _vm.editRecord,
                    },
                  })
                : _vm._e(),
              !_vm.isLoadingData &&
              !_vm.isLoadingAccountableData &&
              _vm.switcherLocal === "accountable-transaction"
                ? _c("c-data-table", {
                    ref: "accountHistory",
                    staticClass:
                      "finance-change-history-table-accountable-transaction",
                    attrs: {
                      levels: 1,
                      "sorted-column": _vm.tableDataAccountable.sortedColumn,
                      "disabled-columns":
                        _vm.tableDataAccountable.disabledColumns,
                      "filtered-columns":
                        _vm.tableDataAccountable.filteredColumns,
                      "active-filtered-columns":
                        _vm.tableDataAccountable.activeFilteredColumns,
                      data: _vm.tableDataAccountable,
                      "reference-list": _vm.referenceFilterList,
                      "empty-records-label": "Изменений пока нет",
                      "operations-status": _vm.operationsStatus,
                    },
                    on: {
                      sortedEvent: _vm.onTableSortAccountable,
                      getReferenceValues: _vm.setColumnReferenceFilterList,
                      "reset-column-filters": function ($event) {
                        _vm.tableDataAccountable.activeFilteredColumns = []
                      },
                      "remove-column-filter":
                        _vm.onColumnFilterRemoveAccountable,
                      "set-column-filter": _vm.onSetColumnFilterAccountable,
                      "set-column-filter-by-index":
                        _vm.onSetColumnFilterByIndexAccountable,
                      "disable-column-sorted-flag":
                        _vm.onDisableColumnSortedFlagAccountable,
                      "change-sorting-column":
                        _vm.onSortingColumnChangeAccountable,
                      remove: _vm.removeTransaction,
                      restore: _vm.restoreTransaction,
                      editRecord: _vm.editRecord,
                    },
                  })
                : _vm._e(),
              !_vm.isLoadingData && _vm.switcherLocal === "deposit"
                ? _c("c-data-table-personal-employee", {
                    ref: "table",
                    class: {
                      "finance-change-history-table-personal-account":
                        _vm.switcherLocal === "personal_account",
                      "finance-change-history-table-deposit":
                        _vm.switcherLocal === "deposit",
                    },
                    attrs: {
                      "empty-records-label": "Записи не найдены",
                      "sorted-column": _vm.tableDataDeposit.sortedColumn,
                      levels: 1,
                      "disabled-columns": [],
                      data: _vm.tableDataDeposit,
                    },
                    on: { sortedEvent: _vm.refreshTable },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.switcherLocal === "personal_account" &&
          !_vm.isLoadingData &&
          !_vm.isLoadingMoreRecords
            ? _c("display-shown-items-count", {
                attrs: {
                  "total-items-count": _vm.totalItemsCount,
                  "shown-items-count": _vm.tableDataPersonal.records.length,
                },
              })
            : _vm._e(),
          _vm.switcherLocal === "accountable-transaction" &&
          !_vm.isLoadingData &&
          !_vm.isLoadingMoreRecords
            ? _c("display-shown-items-count", {
                attrs: {
                  "total-items-count": _vm.totalItemsCountAccountable,
                  "shown-items-count": _vm.tableDataAccountable.records.length,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm.isLoadingData ||
      _vm.isLoadingMoreRecords ||
      _vm.isLoadingAccountableData
        ? _c("c-loader", {
            attrs: {
              label: "Данные загружаются",
              active:
                _vm.isLoadingData ||
                _vm.isLoadingMoreRecords ||
                _vm.isLoadingAccountableData,
              height: _vm.isLoadingMoreRecords ? "200" : "400",
            },
          })
        : _vm._e(),
      _c("top-button", { attrs: { root: ".layout" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }